import { useMutation, useQueryClient } from "react-query";
import { deleteProduct } from "../../../../services/inventory";
import { WarningDialog } from "../../../common";
import { ToastContext } from "../../../../hooks/context";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";

export const DeleteProduct = ({ selectedItem, closeModal = () => {} }) => {
  const [search] = useSearchParams();
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const { mutate: deleteProductFromStore, isLoading: isDeletingProduct } =
    useMutation((data) => deleteProduct(data));

  const handleDeleteProduct = () => {
    deleteProductFromStore(
      {
        id: selectedItem?.id,
        isService: selectedItem?.is_service,
        store_id: search.get("store_id"),
      },
      {
        onSuccess: () => {
          triggerToast("Product deleted successfully", "success");
          queryClient.invalidateQueries(["getProductList"]);
          closeModal();
        },
      },
    );
  };

  return (
    <WarningDialog
      closeModal={() => closeModal()}
      handler={() => handleDeleteProduct()}
      isLoading={isDeletingProduct}
    >
      <p>
        Name: <span className="dark--text">{selectedItem?.name}</span>
      </p>
    </WarningDialog>
  );
};
